import { DISTANCE_UNITS_TYPES, PaceUnits } from '../types.results';

export default function convertPaceUnitsToPaceType(paceUnits: PaceUnits): 'pace' | 'speed' {
  return ~DISTANCE_UNITS_TYPES.map(x => `/${x}`)
    .findIndex(x => paceUnits.endsWith(x))
    ? 'pace'
    : 'speed';
}
